import { setContext } from '@apollo/link-context';
import { ApolloLink, HttpLink } from '@apollo/client';

export const createAppSyncHttpLink = function ({ appSyncApiUrl, getJwtToken }) {
	const authorizationHeaderLink = setContext(
		async (request, previousContext) => {
			let token = null;
			try {
				token = await getJwtToken();
			} catch (e) {
				console.warn('[AppSync] failed to fetch JWT token', e);
			}
			const headers = { ...previousContext.headers };
			if (token && typeof token === 'string') {
				headers.Authorization = token;
			}
			return { ...previousContext, headers };
		}
	);

	return ApolloLink.concat(
		authorizationHeaderLink,
		new HttpLink({ uri: appSyncApiUrl })
	);
};
